import { FirmWalletsAgGrid } from './firmWalletsAgGrid';

export interface FirmWalletsAgGridProps {
    firmId: string;
    showClosedWallets: boolean;
}

export default FirmWalletsAgGrid;